import _ from 'underscore';

export const objectsKeysEqual = ( keyList: string[] = [], object1: object = {}, object2: object = {} ) => {

    let results = [] as Boolean[];

    keyList.map( p => {

        // compare props with equality test in order to re-render or not...
        const prevObj = object1[ p ] ?? {},
              nextObj = object2[ p ] ?? {};

        let comparisonA = objectEquivalenceDiff( prevObj, nextObj ),
            comparisonB = objectEquivalenceDiff( nextObj, prevObj );

        let diffs = _.chain( [
            ..._.values( comparisonA ),
            ..._.values( comparisonB )
        ] )
                     .flatten()
                     .compact()
                     .value();

        if( !_.isEmpty( diffs ) ){
            // console.log( `${ p } is different:` );
            // console.log( diffs );
            results.push( true );
        }
    } );

    return _.isEmpty( results );
}

export const objectEquivalenceDiff = ( objectWithKeysToCompare: object, objectToCompareWith: object ) => {

    let differences: Record<string, Array<string | object>> = {
        diff:    [],
        missing: [],
    };

    for( let i = 0; i < _.size( objectWithKeysToCompare ); i++ ){

        let propName = _.keys( objectWithKeysToCompare )[ i ];

        // If prop does not exist, note that and bail out of comparison
        if( _.isUndefined( objectToCompareWith[ propName ] ) ){
            differences.missing.push( propName );
            continue;
        }

        // If values of same property are not equal,
        // objects are not equivalent
        if( objectWithKeysToCompare[ propName ] !== objectToCompareWith[ propName ] ){
            differences.diff.push( { [ propName ]: objectToCompareWith[ propName ] } );
        }
    }

    return differences;
};

export const isRequiredUpdateObject = function( o: Array<any> | Function ){
    return Array.isArray( o ) || ( o && o.constructor === Object.prototype.constructor );
};

export const deepDiff = function( o1: object, o2: object, p: any ){

    const notify = ( status: string ) => {
        console.warn( 'Update %s', status );
        console.log( '%cbefore', 'font-weight: bold', o1 );
        console.log( '%cafter ', 'font-weight: bold', o2 );
    };

    if( !_.isEqual( o1, o2 ) ){

        console.group( p );

        if( [ o1, o2 ].every( _.isFunction ) ){
            notify( 'avoidable?' );
        } else if( ![ o1, o2 ].every( isRequiredUpdateObject ) ){
            notify( 'required.' );
        } else {
            const keys = _.union( _.keys( o1 ), _.keys( o2 ) );
            for( const key of keys ){
                deepDiff( o1[ key ], o2[ key ], key );
            }
        }

        console.groupEnd();

    } else if( o1 !== o2 ){

        console.group( p );

        notify( 'avoidable!' );

        if( _.isObject( o1 ) && _.isObject( o2 ) ){
            const keys = _.union( _.keys( o1 ), _.keys( o2 ) );
            for( const key of keys ){
                deepDiff( o1[ key ], o2[ key ], key );
            }
        }

        console.groupEnd();
    }
};

export const applyDeepDiff = function( prevProps: object, prevState: object, component: any ){
    deepDiff(
        { props: prevProps, state: prevState },
        { props: component.props, state: component.state },
        component.constructor.displayName );
};

export function findCollectionDeltas( A: Array<object>, B: Array<object>, idProperty: string = 'id', includeChanges = false ){

    let mapA = _.indexBy( A, idProperty );
    let mapB = _.indexBy( B, idProperty );

    let added = _.difference( _.keys( mapB ), _.keys( mapA ) ).map( id => mapB[ id ] );
    let removed = _.difference( _.keys( mapA ), _.keys( mapB ) ).map( id => mapA[ id ] );

    let updated = _.filter( _.keys( mapA ), ( id ) => {
        return mapB[ id ] && !_.isEqual( mapA[ id ], mapB[ id ] )
    } ).map( id => {

        if( includeChanges ){
            return {
                entity:  mapB[ id ],
                changes: _.reduce( mapA[ id ], ( result, value, key ) => _.isEqual( value, mapB[ id ][ key ] ) ? result : result.concat( key ), [] )
            };
        }

        return mapB[ id ];
    } );

    return {
        added:   added,
        removed: removed,
        updated: updated
    };
}

export const noDeltasFound = ( deltas: {
    added: Array<object>,
    removed: Array<object>,
    updated: Array<object>
} ) => {
    if( deltas.added.length > 0 || deltas.removed.length > 0 || deltas.updated.length > 0 ){
        return false;
    }
}
